module.exports = __webpack_public_path__ + "img/page3-5.55994345.png";